var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-form"},[_c('b-row',[_c('b-col',[_c('span',{staticStyle:{"font-size":"18px","color":"#2B3447","font-weight":"600"}},[_vm._v(_vm._s(_vm.$l('table_label_production_batch') || '计划投产批次'))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }